import PropTypes from 'prop-types';

const stateInfo = PropTypes.shape({
  fieldValue: PropTypes.string,
  nodes: PropTypes.arrayOf(
    PropTypes.shape({
      html: PropTypes.string,
      modified_at: PropTypes.string,
      field_type: PropTypes.string,
    })
  ),
});

const baseProps = {
  infoSlug: PropTypes.arrayOf(PropTypes.string),
  stateInfos: PropTypes.arrayOf(stateInfo),
  infoFields: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      slug: PropTypes.string,
      field_format: PropTypes.string,
    })
  ),
  title: PropTypes.string,
};

export const listFrontmatterProps = {
  frontmatter: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    stateTitleAppend: PropTypes.string,
    stateLink: PropTypes.string,
    stateListAppendText: PropTypes.string,
    stateListAppendLink: PropTypes.string,
    stateListAppendLinkIsButton: PropTypes.bool,
    infoSlugHeaders: PropTypes.arrayOf(PropTypes.string),
    miniTool: PropTypes.string,
  }),
};

export const listLayoutProps = {
  ...baseProps,
  ...listFrontmatterProps,
};

export const tableFrontmatterProps = {
  frontmatter: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    infoSlugHeaders: PropTypes.arrayOf(PropTypes.string),
    listRenderer: PropTypes.string,
    miniTool: PropTypes.string,
    stateLink: PropTypes.string,
    stateListAppendLink: PropTypes.string,
    stateListAppendLinkIsButton: PropTypes.bool,
    stateListAppendText: PropTypes.string,
    stateListAppendTextHeader: PropTypes.string,
    stateListGrouping: PropTypes.string,
  }),
};

export const tableLayoutProps = {
  ...baseProps,
  ...tableFrontmatterProps,
};

export const listRendererProps = {
  ...listLayoutProps,
  state: stateInfo,
};

export const rowRendererProps = {
  ...tableLayoutProps,
  state: stateInfo,
};

export const miniToolFrontmatterProps = {
  frontmatter: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    miniTool: PropTypes.string,
  }),
};

export const miniToolProps = {
  ...baseProps,
  ...miniToolFrontmatterProps,
};

export const tableLayoutWithGroupProps = {
  ...baseProps,
  ...rowRendererProps,
  ...listRendererProps,
  state: stateInfo,
};
